import React from 'react';

const TickCheckIcon = () => {
    return (
        <svg className={`svg-inline`} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3.08008 6.01131L5.16555 8.30533L9.33651 3.71729"
                stroke="currentColor"
                strokeWidth="1.30134"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default TickCheckIcon;
